import { _ as _async_to_generator } from "@swc/helpers/_/_async_to_generator";
import { _ as _call_super } from "@swc/helpers/_/_call_super";
import { _ as _class_call_check } from "@swc/helpers/_/_class_call_check";
import { _ as _create_class } from "@swc/helpers/_/_create_class";
import { _ as _inherits } from "@swc/helpers/_/_inherits";
import { _ as _ts_generator } from "@swc/helpers/_/_ts_generator";
import { getAllowList, getOverrideLocaleHeaderAllowList } from "@faire/retailer-visitor-shared/initialize/dark-read/darkReadAllowList";
import { setIntervalIfPossible } from "@faire/retailer-visitor-shared/lib/async-functions/setIntervalIfPossible";
import { getSettingsValues } from "@faire/retailer-visitor-shared/serialized-data/getSettingsValues";
import { getWindow } from "@faire/web--source/common/globals/getWindow";
import { logError } from "@faire/web--source/common/logging";
import { makeObservable } from "@faire/web--source/common/makeObservable";
import { MIN_WIDTH_BREAKPOINTS } from "@faire/web--source/common/media";
import { isWindowUndefined } from "@faire/web--source/common/server-side-rendering/isWindowUndefined";
import { singletonGetter } from "@faire/web--source/common/singletons/getter";
import fetchSetting, { QueryParameters as FetchSettingParams } from "@faire/web-api--source/api/setting/public/get";
import { IPerfDarkReadsConfig } from "@faire/web-api--source/indigofair/settings/IPerfDarkReadsConfig";
import { PERF_DARK_READ_TESTING_ENABLED } from "@faire/web-api--source/indigofair/settings/PERF_DARK_READ_TESTING_ENABLED";
import { PERF_DARK_READ_TESTING_OVERRIDE_LOCALE_HEADER } from "@faire/web-api--source/indigofair/settings/PERF_DARK_READ_TESTING_OVERRIDE_LOCALE_HEADER";
export var DarkReadManager = /*#__PURE__*/ function() {
    "use strict";
    function DarkReadManager(settingName) {
        var _this = this;
        _class_call_check(this, DarkReadManager);
        var _this1 = this;
        this.updateDarkReadConfigsIntervalId = 0;
        // unused-class-members-ignore-next
        this.shouldPerformDarkRead = function() {
            var _this_darkReadConfig;
            var _this_darkReadConfig_probability_value;
            // Check if we fall under the probability
            return Math.random() < ((_this_darkReadConfig_probability_value = (_this_darkReadConfig = _this.darkReadConfig) === null || _this_darkReadConfig === void 0 ? void 0 : _this_darkReadConfig.probability_value) !== null && _this_darkReadConfig_probability_value !== void 0 ? _this_darkReadConfig_probability_value : 1);
        };
        /**
         * Returns true if this dark reads config is enabled and applicable to the given request.
         */ this.shouldMultiplyDarkReads = function(requestOptions) {
            if (!_this.canPerformDarkReads || !_this.shouldPerformDarkRead()) {
                return false;
            }
            try {
                var _this_darkReadConfig_endpoints, _this_darkReadConfig;
                var routeAllowList = getAllowList(requestOptions.method);
                var matchResult = routeAllowList === null || routeAllowList === void 0 ? void 0 : routeAllowList.match(requestOptions.url);
                if (!matchResult) {
                    return false;
                }
                if ((_this_darkReadConfig = _this.darkReadConfig) === null || _this_darkReadConfig === void 0 ? void 0 : (_this_darkReadConfig_endpoints = _this_darkReadConfig.endpoints) === null || _this_darkReadConfig_endpoints === void 0 ? void 0 : _this_darkReadConfig_endpoints.length) {
                    // Config is explicitly allowing a subset.
                    if (!_this.darkReadConfig.endpoints.some(function(e) {
                        try {
                            return new RegExp(e).test(requestOptions.url);
                        } catch (e) {
                            logError(e);
                        // Fall through
                        }
                        return false;
                    })) {
                        return false;
                    }
                }
                // there isn't a :something_token pattern, so it's an exact match
                if (matchResult.match.length === 1 || !/\/:\w+_token($|\/)/.test(matchResult.route)) {
                    return true;
                }
                var tokenMatch = matchResult.match[1];
                // naive token test: it should be 1/2 letters + _ + letters or numbers
                return /^\w{1,2}_(\w|\d)+$/.test(tokenMatch !== null && tokenMatch !== void 0 ? tokenMatch : "");
            } catch (e) {
                return false;
            }
        };
        /**
         * Returns true if the outgoing request has enabled locale overrides (i.e. performing the dark read in
         * a different locale than the outgoing request).
         */ this.shouldOverrideLocaleHeader = function(requestOptions) {
            var routeAllowList = getOverrideLocaleHeaderAllowList(requestOptions.method);
            var matchResult = routeAllowList === null || routeAllowList === void 0 ? void 0 : routeAllowList.match(requestOptions.url);
            if (!matchResult) {
                return false;
            }
            // there isn't a :something_token pattern, so it's an exact match
            if (matchResult.match.length === 1 || !/\/:\w+_token($|\/)/.test(matchResult.route)) {
                return true;
            }
            var tokenMatch = matchResult.match[1];
            // naive token test: it should be 1/2 letters + _ + letters or numbers
            return /^\w{1,2}_(\w|\d)+$/.test(tokenMatch !== null && tokenMatch !== void 0 ? tokenMatch : "");
        };
        this.clearInterval = function() {
            if (_this.updateDarkReadConfigsIntervalId) {
                clearInterval(_this.updateDarkReadConfigsIntervalId);
            }
        };
        this.updateInterval = function() {
            if (_this.canPerformDarkReads) {
                var _this_darkReadConfig;
                var _this_darkReadConfig_next_pulling_delay_in_second, _setIntervalIfPossible;
                _this.updateDarkReadConfigsIntervalId = (_setIntervalIfPossible = setIntervalIfPossible(_this.refresh, ((_this_darkReadConfig_next_pulling_delay_in_second = (_this_darkReadConfig = _this.darkReadConfig) === null || _this_darkReadConfig === void 0 ? void 0 : _this_darkReadConfig.next_pulling_delay_in_second) !== null && _this_darkReadConfig_next_pulling_delay_in_second !== void 0 ? _this_darkReadConfig_next_pulling_delay_in_second : 10 * 60) * 1000)) !== null && _setIntervalIfPossible !== void 0 ? _setIntervalIfPossible : 0;
            }
        };
        this.refresh = /*#__PURE__*/ _async_to_generator(function() {
            var _this_darkReadConfig, _this_darkReadConfig1, _this_darkReadConfig2, previousPollingInterval, config, e, intervalChanged, disabled;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        previousPollingInterval = (_this_darkReadConfig = _this1.darkReadConfig) === null || _this_darkReadConfig === void 0 ? void 0 : _this_darkReadConfig.next_pulling_delay_in_second;
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            fetchSetting(FetchSettingParams.build({
                                setting: _this1.settingName
                            }))
                        ];
                    case 2:
                        config = _state.sent();
                        if (!config) {
                            logError("".concat(_this1.settingName, " has undefined dark-read config"));
                        }
                        _this1.darkReadConfig = config;
                        return [
                            3,
                            4
                        ];
                    case 3:
                        e = _state.sent();
                        // something went wrong... let's stop the dark reads
                        _this1.darkReadConfig = undefined;
                        return [
                            3,
                            4
                        ];
                    case 4:
                        intervalChanged = ((_this_darkReadConfig1 = _this1.darkReadConfig) === null || _this_darkReadConfig1 === void 0 ? void 0 : _this_darkReadConfig1.next_pulling_delay_in_second) !== previousPollingInterval;
                        disabled = !((_this_darkReadConfig2 = _this1.darkReadConfig) === null || _this_darkReadConfig2 === void 0 ? void 0 : _this_darkReadConfig2.enabled);
                        if (disabled || intervalChanged) {
                            _this1.clearInterval();
                        }
                        if (intervalChanged) {
                            _this1.updateInterval();
                        }
                        return [
                            2
                        ];
                }
            });
        });
        makeObservable(this);
        this.settingName = settingName !== null && settingName !== void 0 ? settingName : PERF_DARK_READ_TESTING_ENABLED;
        this.darkReadConfig = IPerfDarkReadsConfig.build(getSettingsValues()[this.settingName]);
        this.updateInterval();
    }
    _create_class(DarkReadManager, [
        {
            key: "darkReadDelayInMs",
            get: function get() {
                var _this_darkReadConfig;
                var _this_darkReadConfig_dark_read_burst_delay_in_second;
                return ((_this_darkReadConfig_dark_read_burst_delay_in_second = (_this_darkReadConfig = this.darkReadConfig) === null || _this_darkReadConfig === void 0 ? void 0 : _this_darkReadConfig.dark_read_burst_delay_in_second) !== null && _this_darkReadConfig_dark_read_burst_delay_in_second !== void 0 ? _this_darkReadConfig_dark_read_burst_delay_in_second : 3) * 1000;
            }
        },
        {
            key: "canPerformDarkReads",
            get: /**
     * Returns true if dark reads are enabled.
     * Note that this does not factor in whether a given request should be performed
     * based on probability - see #shouldPerformDarkRead.
     */ function get() {
                var _this_darkReadConfig;
                return !!((_this_darkReadConfig = this.darkReadConfig) === null || _this_darkReadConfig === void 0 ? void 0 : _this_darkReadConfig.enabled) && !isWindowUndefined();
            }
        },
        {
            key: "darkReadMultiplier",
            get: /**
     * Multiplication factor for the dark read config. Returns zero when not enabled.
     */ function get() {
                var _getWindow, _this_darkReadConfig, _this_darkReadConfig1;
                if (!this.canPerformDarkReads) {
                    return 0;
                }
                var _getWindow_innerWidth;
                var windowWidth = (_getWindow_innerWidth = (_getWindow = getWindow()) === null || _getWindow === void 0 ? void 0 : _getWindow.innerWidth) !== null && _getWindow_innerWidth !== void 0 ? _getWindow_innerWidth : 0;
                var _this_darkReadConfig_multiplication_value, _this_darkReadConfig_mobile_web_multiplication_value_cap;
                return Math.min((_this_darkReadConfig_multiplication_value = (_this_darkReadConfig = this.darkReadConfig) === null || _this_darkReadConfig === void 0 ? void 0 : _this_darkReadConfig.multiplication_value) !== null && _this_darkReadConfig_multiplication_value !== void 0 ? _this_darkReadConfig_multiplication_value : 0, windowWidth < MIN_WIDTH_BREAKPOINTS.TABLET ? (_this_darkReadConfig_mobile_web_multiplication_value_cap = (_this_darkReadConfig1 = this.darkReadConfig) === null || _this_darkReadConfig1 === void 0 ? void 0 : _this_darkReadConfig1.mobile_web_multiplication_value_cap) !== null && _this_darkReadConfig_mobile_web_multiplication_value_cap !== void 0 ? _this_darkReadConfig_mobile_web_multiplication_value_cap : MAX_DARK_READ_MULTIPLIER_MOBILE : MAX_DARK_READ_MULTIPLIER);
            }
        }
    ]);
    return DarkReadManager;
}();
DarkReadManager.get = singletonGetter(DarkReadManager);
DarkReadManager.localeOverride = function() {
    return LocalesOverrideDarkReadManager.get();
};
var LocalesOverrideDarkReadManager = /*#__PURE__*/ function(DarkReadManager) {
    "use strict";
    _inherits(LocalesOverrideDarkReadManager, DarkReadManager);
    function LocalesOverrideDarkReadManager() {
        _class_call_check(this, LocalesOverrideDarkReadManager);
        return _call_super(this, LocalesOverrideDarkReadManager, [
            PERF_DARK_READ_TESTING_OVERRIDE_LOCALE_HEADER
        ]);
    }
    return LocalesOverrideDarkReadManager;
}(DarkReadManager);
LocalesOverrideDarkReadManager.get = singletonGetter(LocalesOverrideDarkReadManager);
var MAX_DARK_READ_MULTIPLIER = 10;
var MAX_DARK_READ_MULTIPLIER_MOBILE = 5;
